import React from 'react';

const IT = () => {
    return (
        <div className="skills__content">
            <h3 className="skills__title">IT Specialist</h3>
            <div className="skills__box">
                <div className="skills__group">

                    <div className="skills__data">
                        <i class='bx bxs-badge-check skills__icon' ></i>
                        
                        <div>
                            <h3 className="skills__name">Active Directory</h3>
                            <span className="skills__level"></span>
                        </div>
                    </div>

                    <div className="skills__data">
                        <i class='bx bxs-badge-check skills__icon' ></i>
                        <div>
                            <h3 className="skills__name">Microsoft Office 365</h3>
                            <span className="skills__level"></span>
                        </div>
                    </div>

                    <div className="skills__data">

                        <i class='bx bxs-badge-check skills__icon' ></i>
                        <div>
                            <h3 className="skills__name">Bash/CMD/PowerShell</h3>
                            <span className="skills__level"></span>
                        </div>
                    </div>


                    <div className="skills__data">
                        <i class='bx bxs-badge-check skills__icon' ></i>
                        <div>
                            <h3 className="skills__name">Linux/Windows/Mac OS</h3>
                            <span className="skills__level"></span>
                        </div>
                    </div>

                    <div className="skills__data">
                        <i class='bx bxs-badge-check skills__icon' ></i>
                        <div>
                            <h3 className="skills__name">DHCP/Firewalls/VPN</h3>
                            <span className="skills__level"></span>
                        </div>
                    </div>

                    <div className="skills__data">
                        <i class='bx bxs-badge-check skills__icon'></i>
                        <div>
                            <h3 className="skills__name">Hardware</h3>
                            <span className="skills__level"></span>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    );
}

export default IT;